__webpack_require__.p = "/Kiran-Portfolio/";